<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HYUEWO/tc-custom/9781452171401.jpg?1737778778054" alt="This image is the cover for the book Cheese Balls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cheese Balls
      </h1>
      <p class="bookDescription body article font2">
        <b>From afternoon snacks to holiday crowd-pleasers, savor the many varieties of this retro treat with more than thirty no-fuss recipes.</b><br/><br/>Forget the cheese plate! A cheese ball is the perfect way to shake up the appetizer spread. This cheerfully cheesy cookbook offers more than thirty simple recipes as well as quick and easy dippers and toppings to serve alongside.<br/><br/><i>Cheese Balls</i> features the classic Port Wine, the zesty Jalapeño Popper, the sweet Lemon Poppy Seed, the elegant Garden Herb, and many more. With cheese balls for every occasion and time of year, helpful tips for rolling the perfect ball and creating fun shapes, plus suggestions of what to serve alongside each recipe, <i>Cheese Balls</i> is a delicious party waiting to happen.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dena Rayess, Heami Lee
      </h2>
      
      <p class="authorDescription body article">Dena Rayess is a food writer and recipe developer. She lives in San Francisco.Heami Lee is a photographer based in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?177bc71f